import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** "13 November 2026", locale-neutral enough for a banner; null for a missing or invalid date. */
export function formatGraceDate(iso) {
    if (!iso)
        return null;
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return null;
    return d.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
}
/** Banner for roles that must enrol in two-step sign-in (#1501): grace date before, blocked notice after. */
export function MfaEnforcementBanner({ enrollmentRequired, graceEndsAt, enrollAction, now, className }) {
    if (!enrollmentRequired)
        return null;
    const date = formatGraceDate(graceEndsAt);
    const ends = graceEndsAt ? new Date(graceEndsAt).getTime() : Number.NaN;
    const blocked = Number.isFinite(ends) && ends <= (now ?? new Date()).getTime();
    return (_jsxs("aside", { className: ["lumora-mfa-banner", className].filter(Boolean).join(" "), "data-lumora-view": "mfa-enforcement", "data-blocked": blocked ? "true" : undefined, role: blocked ? "alert" : "status", children: [_jsx("p", { children: blocked
                    ? "Two-step sign-in is required. Changes are blocked until you set it up."
                    : date
                        ? `Set up two-step sign-in by ${date}. After that, changes are blocked until you do.`
                        : "Set up two-step sign-in. Changes will be blocked until you do." }), _jsx("span", { className: "lumora-mfa-banner__action", children: enrollAction })] }));
}
//# sourceMappingURL=MfaEnforcementBanner.js.map